{
  "ui": {
    "feedback": "Povratne informacije",
    "credits": "Ustvarjalci",
    "currentMaintainer": "Trenutni skrbnik",
    "maintainerPeriod": "Od leta 2026 dalje",
    "originalTeam": "Prvotna ekipa",
    "creditsCampaigns": "Džungla in božič",
    "moreSettings": "Več nastavitev",
    "chooseLanguage": "Izberi jezik",
    "notebookTools": "Orodja zvezka",
    "visualGuide": "Slikovni vodnik",
    "templeSoon": "Kmalu",
    "playAdventure": "Igraj",
    "story": "Zgodba",
    "loadingAdventure": "Pripravljamo se na pustolovščino…",
    "storyOpening": "Šolski izlet v džunglo. Marco in Sophia raziskujeta s prijatelji. Pisana ptica pritegne Marcovo pozornost in on ji sledi med drevesa. Nenadoma je sam. Pomagaj raziskovalcema najti pot!",
    "storyEnding": "Marco in Sophia skupaj prispeta do izgubljenega templja. Skrivnostni obraz varuje vhod. Čaka ju nova pustolovščina!",
    "blockCategories": "Zavihki zvezka",
    "actions": "Dejanja",
    "loops": "Zanke",
    "conditions": "Pogoji",
    "title": "Run Marco! — Pustolovščina v tvojem zvezku",
    "home": "Domača stran Run Marco",
    "map": "Zemljevid pustolovščine",
    "worlds": "Izberi pustolovščino",
    "notebook": "Moj zvezek",
    "notebookToggle": "Odpri ali zapri zvezek",
    "notebookOpen": "Odpri zvezek",
    "notebookClose": "Opazuj pot",
    "page": "Stran {number}",
    "level": "Pot {number}",
    "run": "Gremo!",
    "stop": "Ustavi",
    "step": "En korak",
    "stepTitle": "Izvedi en ukaz",
    "reset": "Nazaj na začetek",
    "add": "Dodaj",
    "addLabel": "Izberi blok za dodajanje",
    "addHint": "Poveži bloke in pritisni Igraj.",
    "undo": "Razveljavi",
    "clear": "Nova stran",
    "hint": "Majhen namig",
    "help": "Kako igrati",
    "settings": "Nastavitve",
    "language": "Jezik igre",
    "blockLanguage": "Jezik blokov",
    "blockLanguageNote": "Za bloke lahko izbereš drug jezik.",
    "musicOn": "Vklopi zvok",
    "musicOff": "Izklopi zvok",
    "sound": "Glasba in zvočni učinki",
    "speed": "Hitrost pustolovščine",
    "chooseExplorer": "Izberi raziskovalca",
    "explorer": "Raziskovalec",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Zapri",
    "done": "Raziskujmo!",
    "loading": "Iščemo pot…",
    "loadError": "Pustolovščine ni bilo mogoče naložiti. Osveži stran in poskusi znova.",
    "imageError": "Nekaterih slik ni bilo mogoče naložiti. Osveži stran.",
    "gemGoal": "Poišči dragulj",
    "goal": "Poišči zlato zvezdo",
    "cover": "Osvetli vsako polje samo enkrat",
    "lit": "Osvetljena polja: {count} / {total}",
    "explored": "Raziskane poti: {count} / {total}",
    "facing": "Gleda {direction} {arrow}",
    "boardLabel": "{name} na poti {level}, gleda {direction}. {steps}. {objective}.",
    "up": "gor",
    "down": "dol",
    "left": "levo",
    "right": "desno",
    "steps_one": "{count} korak",
    "steps_other": "{count} korakov",
    "blocks_one": "{count} blok",
    "blocks_other": "{count} blokov",
    "stars_one": "{count} zvezda",
    "stars_other": "{count} zvezd",
    "place": "Dodaj bloke",
    "atEnd": "Na konec",
    "insideRepeat": "V ponovitev {number}",
    "insideIf": "V če {number}",
    "insideElse": "V sicer {number}",
    "readyFirst": "Majhen korak. Dodaj blok naprej in gremo!",
    "ready": "Kam gremo? Naredi načrt v zvezku.",
    "back": "Spet na začetku. Tvoji bloki so pripravljeni na nov poskus.",
    "empty": "Najprej dodaj blok v zvezek.",
    "win": "Pot je najdena!",
    "winCover": "Vsa pot sveti!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Kakšna pustolovščina!",
    "simpler": "Lahko uporabiš manj blokov?",
    "complete": "Pot je opravljena! Tvoje najboljše zvezde so shranjene.",
    "next": "Naslednja pot",
    "allWorlds": "Več pustolovščin",
    "replay": "Igraj znova",
    "shortGoal": "Skoraj! Dodaj še nekaj blokov, da dosežeš zvezdo.",
    "shortGem": "Skoraj! Dodaj še nekaj blokov, da dosežeš dragulj.",
    "shortCover": "Nekatera polja so še temna. Kako jih dosežemo?",
    "checking": "Opazujemo pot…",
    "paused": "Ustavljeno. Igraj začne znova od začetka.",
    "going": "Na pot!",
    "stepped": "Korak bližje. Za nadaljevanje pritisni En korak ali Igraj.",
    "clueCover": "Začni ob robu in prehodi celo obliko. S skokom preskočiš polje, ne da bi ga osvetlil.",
    "clueCondition": "Poglej pot pred seboj. Pogoj pomaga raziskovalcu izbrati dejanje.",
    "clueRepeat": "Kateri koraki se ponavljajo? Vstavi ta vzorec v ponavljalni blok.",
    "clueForward": "Naprej sledi raziskovalčevemu pogledu. Preštej polja do zvezde.",
    "clueGem": "Naprej sledi raziskovalčevemu pogledu. Preštej polja do dragulja.",
    "clueTurn": "Obrat spremeni smer brez premika. S prstom sledi poti.",
    "mapNote": "Izberi pot. Tvoje najboljše zvezde ostanejo shranjene.",
    "mapLevel": "Pot {number}: {name}. {stars}.",
    "locked": "Opravi prejšnjo pot, da odkleneš to.",
    "soundBlocked": "Dotakni se gumba za zvok, da slišiš pustolovščino.",
    "clearTitle": "Začnemo novo stran?",
    "clearNote": "Bloki za to pot bodo izbrisani. Razveljavi jih lahko vrne.",
    "keep": "Obdrži moje bloke",
    "clearConfirm": "Izbriši bloke",
    "fresh": "Nova stran. Kam nas bo vodil tvoj naslednji načrt?",
    "localProgress": "Tvoj napredek se shrani v tej napravi.",
    "helpBuild": "Naredi načrt",
    "helpBuildText": "Povleci bloke v zvezek in jih poveži ali se dotakni bloka, da ga dodaš. Izberi »V ponovitev«, da dodaš korake v zanko.",
    "helpTurn": "Sledi raziskovalcu",
    "helpTurnText": "Naprej sledi pogledu. Levo in desno obračata na mestu. Skok prepotuje dve polji.",
    "helpTry": "Poskusi, opazuj in poskusi znova",
    "helpTryText": "Pritisni Igraj za načrt ali En korak za en ukaz. Ukrivljena puščica vrne na začetek in ohrani bloke.",
    "helpWorlds": "Vsaka pustolovščina ima cilj",
    "helpWorldsText": "V Džungli poišči dragulj. V božični pustolovščini osvetli vsako prosto polje enkrat. V Templju in Egejskem morju dokončaj popravila in prikazane cilje ter pridi do izhoda.",
    "noTrail": "Tam ni poti! Poskusi se najprej obrniti.",
    "broken": "Ta most je polomljen. Ga lahko preskočiš?",
    "blocked": "Nekaj ovira pot. Poskusi skok ali drugo pot.",
    "alreadyLit": "To polje že sveti. Vsako polje obišči samo enkrat.",
    "loopError": "Ta načrt se ponavlja v nedogled. Poskusi spremeniti zanko.",
    "repeatError": "Izberi število ponovitev od 1 do 99.",
    "unsupported": "Odstrani nepodprti blok in poskusi znova.",
    "connect": "Poveži bloke v eno verigo in pritisni Igraj.",
    "path": "pot",
    "steps_two": "{count} koraka",
    "blocks_two": "{count} bloka",
    "stars_two": "{count} zvezdi",
    "steps_few": "{count} koraki",
    "blocks_few": "{count} bloki",
    "stars_few": "{count} zvezde",
    "backpack": "Nahrbtnik",
    "templeGems": "Dragulji templja",
    "gemsCollected": "Dragulji: {count} / {total}",
    "gemsReady": "Vsi dragulji so zbrani!",
    "aegeanTitle": "Skrivnosti Egejskega morja",
    "harbour": "Pristanišče",
    "aegeanDescription": "Razišči pristanišče: popravljaj postaje, znova uporabljaj podprograme in vsakemu naročilu priloži število.",
    "templeBetaNote": "Beta · Uganke in lekcije še izpopolnjujemo",
    "aegeanBetaNote": "Beta · Prve 3 stopnje v pristanišču",
    "seasonal": "Sezonska pustolovščina",
    "choosePreview": "Izberi poskusno stopnjo",
    "repairs": "Popravila",
    "reachExit": "Pridi do izhoda",
    "taskRequirements": "Cilji naloge",
    "lessonGuided": "Vodena vaja · dopolni pripravljeni program",
    "lessonRepair": "Odpravljanje napak · popravi pripravljeni program",
    "lessonChallenge": "Izziv · sestavi svoj program",
    "acc_define_parameter": "Podprogram",
    "acc_call_argument": "Pokliči podprogram",
    "acc_repeat_parameter": "Ponavljaj z vhodom",
    "parameter": "parameter",
    "argument": "pošlji",
    "callInput": "Vhod tega klica",
    "inputWaiting": "Zaženi program ali izvedi en ukaz, da vidiš naslednji vhod.",
    "argumentMismatch": "Podprogram s parametrom potrebuje klic s številom. Brez parametra uporabi običajen klic.",
    "unsetParameter": "Parameter uporabljaj samo v podprogramu, ki ga prejme. Parametri so ločeni od skupnega pomnilnika.",
    "memoryObjective": "Preveri zapis popravil in zahteve pri izhodu. Sprejet je vsak program, ki jih izpolni.",
    "gate": "Pot je zaprta. Preveri nedokončana popravila.",
    "noPickup": "Preden pobereš orodje, stopi nanj.",
    "creditLead": "Vodenje ekipe in razvoj programske opreme",
    "creditArt": "Ilustracije in scenografija",
    "creditAnimation": "Animacija",
    "creditUX": "Oblikovanje vmesnika in uporabniške izkušnje",
    "creditDesign": "Oblikovanje igre",
    "creditStory": "Pisanje zgodbe",
    "creditAudio": "Glasba in zvočna tehnika",
    "lightLamp": "Prižgi svetilko",
    "oilLamp": "Oljna svetilka",
    "dustyStation": "prašna postaja",
    "betaLabel": "Beta",
    "noLamp": "Stopi na ugasnjeno svetilko, preden jo prižgeš.",
    "collected": "Orodje pobrano · pripravljeno za uporabo",
    "dustyPrompt": "Pred uporabo čopiča stopi na prašno postajo.",
    "lampMissing": "Najprej vzemi oljno svetilko. Poglej v nahrbtnik.",
    "recursiveRoutine": "Ta podprogram kliče samega sebe. Uporabi drug podprogram; rekurzivni klici še niso na voljo."
  },
  "content": {
    "jungle.title": "Odprava v džunglo",
    "jungle.description": "Sledi poti do izgubljenega templja.",
    "jungle-1": "Prvi koraki",
    "jungle-2": "Malo dlje",
    "jungle-3": "Za vogalom",
    "jungle-4": "Spremeni smer",
    "jungle-5": "Sledi poti",
    "jungle-6": "Nova pot",
    "jungle-7": "Nove steze",
    "jungle-8": "Križišče v džungli",
    "jungle-9": "Poišči pot",
    "jungle-10": "Razmišljaj vnaprej",
    "jungle-11": "Dolga pot",
    "jungle-12": "Vijugasta pot",
    "jungle-13": "Pogumen skok",
    "jungle-14": "Pojavijo se vzorci",
    "jungle-15": "Ponovi ritem",
    "jungle-16": "Izberi pot",
    "jungle-17": "Poglej pred skokom",
    "jungle-18": "Beri pot",
    "jungle-19": "Pameten ovinek",
    "jungle-20": "Pod krošnjami",
    "jungle-21": "Graditelj mostov",
    "jungle-22": "Onkraj reke",
    "jungle-23": "Razišči ruševine",
    "jungle-24": "Kamen in les",
    "jungle-25": "Večji skok",
    "jungle-26": "Sledi namigom",
    "jungle-27": "Višje",
    "jungle-28": "Raziskuj naprej",
    "jungle-29": "Vijugaste steze",
    "jungle-30": "Skrivni vrt",
    "jungle-31": "Skriti vzorci",
    "jungle-32": "Starodavne poti",
    "jungle-33": "Zadnji zavoji",
    "jungle-34": "Proti templju",
    "jungle-35": "Skoraj tam",
    "jungle-36": "Izgubljeni tempelj",
    "winter.title": "Zimska pot",
    "winter.description": "Osvetli vsak odtis stopala.",
    "winter-1": "Koraki v snegu",
    "winter-2": "Druga smer",
    "winter-3": "Zamrznjeni vogali",
    "winter-4": "Dolgi ovinek",
    "winter-5": "Snežinka",
    "winter-6": "Zimske zanke",
    "winter-7": "Raziskovalec ledu",
    "winter-8": "Zavoji in obrati",
    "winter-9": "Ledena logika",
    "winter-10": "Iskalec vzorcev",
    "winter-11": "Mojster poti",
    "winter-12": "Zimski čudež",
    "temple.title": "Izgubljeni tempelj",
    "temple.description": "Štirideset povezanih sob. Obnovi nebesno napravo z orodji, pomnilnikom in lastnimi podprogrami."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Koš je prazen",
    "OPEN_TRASH": "Odpri koš",
    "BLOCK_LABEL_BEGIN_STACK": "Začetek verige",
    "WORKSPACE_LABEL_1_STACK": "1 veriga blokov",
    "WORKSPACE_LABEL_MANY_STACKS": "Verige blokov: %1",
    "ARIA_TYPE_FIELD_NUMBER": "število",
    "ARIA_TYPE_FIELD_DROPDOWN": "spustni seznam",
    "ARIA_TYPE_FIELD_IMAGE": "slika",
    "WORKSPACE_LABEL_PLAIN": "Moj zvezek",
    "FIELD_LABEL_EDIT_PREFIX": "Uredi %1",
    "BLOCK_LABEL_HAS_INPUT": "ima vhod",
    "BLOCK_LABEL_HAS_INPUTS": "ima vhode",
    "BLOCK_LABEL_HAS_BRANCHES": "veje: %1",
    "FIELD_LABEL_OPTION_INDEX": "Možnost %1",
    "INPUT_LABEL_EMPTY": "Prazno",
    "BLOCK_LABEL_DISABLED": "onemogočeno",
    "BLOCK_LABEL_COLLAPSED": "strnjeno",
    "BLOCK_LABEL_BEGIN_PREFIX": "Začetek: %1",
    "INPUT_LABEL_END_STATEMENT": "Konec: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "besedilo",
    "ARIA_TYPE_FIELD_INPUT": "vhod",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "ime vhoda",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "ime podprograma"
  }
}
